import {removeTableRow, buildSelectOptions} from "./shared";

//Sorting
export function addSortingRow(data) {
    $('#addCashBtn').on('click', function (e) {
        e.preventDefault();
        $('#prepareCashTable > tbody').append(sortingCashRow(data));
        removeTableRow();
    })
}

export function redoSortingCashTable(data) {
    var elem = $('#prepareCashTable > tbody');
    elem.empty();
    elem.append(sortingCashRow(data, false));
}

export function sortingCashRow(data, removable=true) {
    let btnStr = '<th><button class="btn btn-sm btn-danger remove-btn" type="button">Remove</button></th>';
    if (!removable) {
        btnStr = '<th><button class="btn btn-sm btn-danger" type="button">Remove</button></th>';
    }
    return `
        <tr>
             <td>
                 <select name="denom" class="form-control form-control-sm" required>
                    <option value="">Choose...</option>
                    ${buildSelectOptions(data)}
                 </select>
             </td>
             <td>
                 <input type="number" min="1" step="1" name="denomCount" required class="form-control form-control-sm">
             </td>
             <td>
                 <input type="text" name="batchLabel" required value="N/A" class="form-control form-control-sm">
             </td>
             <th>
                ${btnStr}
             </th>
        </tr>`;

}
//Mutilated Sorting
export function addMutilatedSortingRow(data) {
    $('#addMutilatedSortingCashBtn').on('click', function (e) {
        e.preventDefault();
        $('#prepareMutilatedCashTable > tbody').append(sortingMutilatedCashRow(data));
        removeTableRow();
    })
}

export function redoMutilatedSortingCashTable(data) {
    var elem = $('#prepareMutilatedCashTable > tbody');
    elem.empty();
    elem.append(sortingMutilatedCashRow(data, false));
}

export function sortingMutilatedCashRow(data, removable=true) {
    let btnStr = '<th><button class="btn btn-sm btn-danger remove-btn" type="button">Remove</button></th>';
    if (!removable) {
        btnStr = '<th><button class="btn btn-sm btn-danger" type="button">Remove</button></th>';
    }
    return `
        <tr>
             <td>
                 <select name="mutilatedDenom" class="form-control form-control-sm" required>
                    <option value="">Choose...</option>
                    ${buildSelectOptions(data)}
                 </select>
             </td>
             <td>
                 <input type="number" min="1" step="1" name="mutilatedDenomCount" required class="form-control form-control-sm">
             </td>
             <td>
                 <input type="text" name="mutilatedBatchLabel" required value="N/A" class="form-control form-control-sm">
             </td>
              <td>
                <select class="form-select form-select-sm" required name="mutilatedCashValue">
                    <option value="">Choose...</option>
                    <option value="FULL">FULL</option>
                    <option value="HALF">HALF</option>
                    <option value="ZERO">ZERO</option>
                </select>
            </td>
             <th>
                ${btnStr}
             </th>
        </tr>`;

}
